(() => {
  const form = document.getElementById('TenznEnquiry');
  if (!form || form.dataset.leadTrackingReady === 'true') return;
  form.dataset.leadTrackingReady = 'true';
  const key = 'tenzn:enquiry-pending:v1';
  const ttl = 30 * 60 * 1000;
  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
    catch (_) { return null; }
  };
  const remove = () => {
    try { sessionStorage.removeItem(key); return true; }
    catch (_) { return false; }
  };
  const write = value => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { return false; }
  };
  if (form.querySelector('[data-enquiry-error]')) remove();
  if (!form.querySelector('[data-enquiry-success]')) {
    form.addEventListener('submit', event => {
      if (event.defaultPrevented || !form.checkValidity()) return;
      try {
        write({ id: crypto.randomUUID(), at: Date.now(), path: location.pathname });
      } catch (_) { remove(); }
    });
    return;
  }
  const pending = read();
  if (!pending || typeof pending.id !== 'string' || !/^[a-f0-9-]{36}$/.test(pending.id) ||
      typeof pending.at !== 'number' || Date.now() < pending.at ||
      Date.now() - pending.at > ttl || pending.path !== location.pathname) {
    remove();
    return;
  }
  let attempts = 0;
  const publish = () => {
    if (read()?.id !== pending.id) return;
    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish === 'function') {
      if (!remove()) return;
      try {
        const accepted = analytics.publish('tenzn:enquiry_submitted', {
          event_id: pending.id,
          form_id: 'TenznEnquiry'
        });
        if (accepted !== false) return;
      } catch (_) {}
      if (!write(pending)) return;
    }
    attempts += 1;
    if (attempts < 60) setTimeout(publish, 500);
  };
  publish();
})();
